import React from 'react'
import styles from "./SocialMediaShare.module.css";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faFacebookSquare, faTwitter, faLinkedinIn} from '@fortawesome/free-brands-svg-icons'

const TWITTER_TEXT = "Check out this page in the D&AD Annual"
const TWITTER_HASHTAGS = "dandad20,design,creativity"

const SocialMediaShare = ({url, extraLinkClass = '', extraContainerClass = '', label = 'share on'}) => {
    const encodedUrl = encodeURIComponent(url)

    return (
        <>
            <div className={[styles.SocialMediaShare, extraContainerClass].join(" ")}>
                {label}
                <ul>
                    <li><a className={`social-link ${extraLinkClass}`} target="_blank" rel="noopener noreferrer" href={`http://twitter.com/share?text=${encodeURIComponent(TWITTER_TEXT)}&url=${encodedUrl}&hashtags=${TWITTER_HASHTAGS}`}><FontAwesomeIcon icon={faTwitter} /></a></li>
                    <li><a className={`social-link ${extraLinkClass}`} target="_blank" rel="noopener noreferrer" href={`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`}><FontAwesomeIcon icon={faFacebookSquare} /></a></li>
                    <li><a className={`social-link ${extraLinkClass}`} target="_blank" rel="noopener noreferrer" href={`https://www.linkedin.com/shareArticle?mini=true&url=${encodedUrl}`}><FontAwesomeIcon icon={faLinkedinIn} /></a></li>
                </ul>
            </div>
            <div className={styles.spacer}></div>
        </>
    )
}

export default SocialMediaShare;